import React, { Component } from 'react';
import {Button, Form, Modal, Select, Table, message } from "antd";
import styled from 'styled-components';
import StaffAPI from '@/api/staff';
import StoreAPI from '@/api/store';
import utils from '@/utils/auth';
const Container = styled.div`
  .search-wrapper {
    padding: 25px;
    margin-bottom: 30px;
    background-color: #fafafa;
    .search {
      display: flex;
      align-items: center;
      .search-input {
        width: 260px;
      }
    }
  }
`;

const ModalWrapper = styled.div`
  margin: 0 auto;
  padding: 0 40px;
  .item {
    display: flex;
    min-height: 40px;
    .label {
      position: relative;
      width: 120px;
      white-space: nowrap;
      &.required::before {
        content: '*';
        position: absolute;
        top: 10%;
        left: -8px;
        color: red;
        vertical-align: middle;
      }
      &::after {
        content:"";
        width: 100%;
        overflow: hidden;
        height: 0;
      }
    }
    .value {
      width: 200px;
    }
  }
`;

const TechModalWrapper = styled.div`
  margin: 0 auto;
  padding: 0 40px;
  .item {
    display: flex;
    height: 40px;
  }
`;

class StaffManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        kdtId: '',
        itemTags: '',
        pageNum: 1,
        pageSize: 10
      },
      rankList: [],
      total: 0,
      yzStoreList: [],
      tagList: [],

      rankServiceModalVisible: false, // 职级服务关联 展示
      itemInfo: {},

      techModalVisible: false,
      rankInfo: {},
      searchStaffParams: {
        kdtId: '',
        positionRankId: '',
        pageNum: 1,
        pageSize: 5
      },
      staffList: [],
      staffTotal: 0,
    };
  }

  componentDidMount() {
    this.initPage();
    this.initStoreList();
    this.initServiceTagList();
  }

  initPage = () => {
    const { searchParams } = this.state;
    StaffAPI.queryStaffBindServiceList(searchParams)
    .then(({ items: rankList, paginator }) => {
      const { totalCount: total } = paginator;
      this.setState({ rankList, total });
    });
  }

  initStoreList = () => {
    StoreAPI.queryYzStoreList()
      .then(yzStoreList => {
        this.setState({ yzStoreList: [{ kdtName: '全部', kdtId: '' }, ...yzStoreList] });
      });
  }

  initServiceTagList = () => {
    StaffAPI.queryServiceTagList()
      .then(tagList => {
        this.setState({ tagList: tagList.map(o => ({ label: o, value: o })) });
      });
  }

  onSearch = () => {
    this.setState({
      searchParams: Object.assign(this.state.searchParams, { pageNum: 1 })
    }, this.initPage);
  }

  onPageChange = (current, pageSize) => {
    this.setState({
      searchParams: Object.assign(this.state.searchParams, { pageNum: current, pageSize })
    }, this.initPage);
  }

  showRankServiceModal = item => {
    this.setState({ itemInfo: Object.assign({}, item), rankServiceModalVisible: true });
  }

  serviceBindConfirm = () => {
    const { searchParams, itemInfo } = this.state;
    const { kdtId } = searchParams;
    const { positionRankId, itemTags } = itemInfo;
    StaffAPI.staffBindServiceTags({ kdtId, positionRankId, itemTags })
      .then(state => {
        if (state) {
          message.success('更新成功');
          this.setState({ rankServiceModalVisible: false }, this.initPage);
        }
      });
  }

  showTechModal = item => {
    const { kdtId, positionRankId } = item;
    this.setState({
      rankInfo: Object.assign({}, item),
      searchStaffParams: Object.assign(this.state.searchStaffParams, {
        kdtId,
        positionRankId,
        pageNum: 1,
      }),
      techModalVisible: true,
    }, this.queryStaffList);
  }

  queryStaffList = () => {
    const { searchStaffParams } = this.state;
    StaffAPI.queryRankBindStaffList(searchStaffParams)
      .then(({ items: staffList, paginator }) => {
        const { totalCount: staffTotal } = paginator;
        this.setState({ staffList: staffList.map((o, index) => ({ ...o, index })), staffTotal });
      });
  }

  onStaffPageChange = (current, pageSize) => {
    this.setState({
      searchStaffParams: Object.assign(this.state.searchStaffParams, { pageNum: current, pageSize })
    }, this.queryStaffList);
  }

  render() {
    const status = utils.checkUserHasBtnPermission(this.props.location.pathname);

    const { searchParams, rankList, total, yzStoreList, tagList, itemInfo, rankServiceModalVisible, techModalVisible, rankInfo, searchStaffParams, staffList, staffTotal } = this.state;
    const columns = [
      {
        title: '手艺人职级名称',
        dataIndex: 'positionRankName',
        key: 'positionRankName'
      },
      {
        title: '关联手艺人',
        render: item => <Button type="link" disabled={!status} onClick={() => this.showTechModal(item)}>{item.technicianCount}</Button>
      },
      {
        title: '关联服务',
        render: ({ itemTags }) => itemTags.join(',')
      },
      {
        title: '归属店铺',
        dataIndex: 'kdtName',
        key: 'kdtName'
      },
      {
        title: '操作',
        render: item => <Button type="link" disabled={!status} onClick={() => this.showRankServiceModal(item)}>编辑</Button>
      }
    ];

    const staffColumns = [
      {
        title: '手艺人名称',
        dataIndex: 'username',
        key: 'username',
        width: 300
      },
      {
        title: '联系方式',
        dataIndex: 'mobile',
        key: 'mobile'
      }
    ];

    return (
        <Container>
          <div className="search-wrapper">
            <div className="search">
              <Form layout="inline">
                {
                  utils.isUserHeadQuarter() && <Form.Item label="归属门店">
                      <Select
                          allowClear
                          showSearch
                          style={{ width: 200 }}
                          value={searchParams.kdtId}
                          options={yzStoreList}
                          optionFilterProp="kdtName"
                          placeholder="请选择门店"
                          fieldNames={{
                            label: 'kdtName',
                            value: 'kdtId'
                          }}
                          onChange={value => {
                            this.setState({ searchParams: Object.assign(searchParams, { kdtId: value || '' }) });
                          }}
                      />
                  </Form.Item>
                }
                <Form.Item label="服务标签">
                <Select
                  allowClear
                  mode="tags"
                  style={{ width: 200 }}
                  options={tagList}
                  placeholder="请选择服务标签"
                  onChange={value => {
                    this.setState({ searchParams: Object.assign(searchParams, { itemTags: value.join(',') }) })
                  }}
                />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" onClick={this.onSearch}>查询</Button>
                </Form.Item>
              </Form>
            </div>
          </div>

          <div className="content-wrapper">
          <Table
              rowKey="positionRankId"
              columns={columns}
              dataSource={rankList}
              pagination={{
                current: searchParams.pageNum,
                pageSize: searchParams.pageSize,
                total,
                hideOnSinglePage: false,
                showTotal: total => `共${total}条`,
                onChange: this.onPageChange
              }}
            />
          </div>

          <Modal
              title="职级服务关联"
              open={rankServiceModalVisible}
              maskClosable={false}
              onOk={this.serviceBindConfirm}
              onCancel={() => this.setState({ rankServiceModalVisible: false })}
          >
            <ModalWrapper>
              <div className="item">
                <div className="label">手艺人职级名称：</div>
                <div className="value">{itemInfo.positionRankName}</div>
              </div>
              <div className="item">
                <div className="label required">关联服务：</div>
                <div className="value">
                  <Select
                    allowClear
                    style={{ width: 200 }}
                    placeholder="请选择服务标签"
                    options={tagList}
                    value={itemInfo.itemTags}
                    mode="tags"
                    onChange={value => {
                      this.setState({ itemInfo: Object.assign(itemInfo, { itemTags: value }) })
                    }}
                  />
                </div>
              </div>
            </ModalWrapper>
          </Modal>

          <Modal
              title="查看手艺人"
              width={800}
              open={techModalVisible}
              maskClosable={false}
              onCancel={() => this.setState({ techModalVisible: false })}
              footer={[
                <Button key="close" onClick={() => this.setState({ techModalVisible: false })}>关闭</Button>
              ]}
          >
            <TechModalWrapper>
              <div className="item">
                <div className="label">归属门店：</div>
                <div className="value">{rankInfo.kdtName}</div>
              </div>
              <div className="item">
                <div className="label">职级名称：</div>
                <div className="value">{rankInfo.positionRankName}</div>
              </div>
              <div className="item">
                <div className="label">手艺人列表：</div>
              </div>
              <Table
                bordered
                rowKey="index"
                columns={staffColumns}
                dataSource={staffList}
                pagination={{
                  current: searchStaffParams.pageNum,
                  pageSize: searchStaffParams.pageSize,
                  total: staffTotal,
                  hideOnSinglePage: false,
                  showTotal: total => `共${total}条`,
                  onChange: this.onStaffPageChange
                }}
              />
            </TechModalWrapper>
          </Modal>
        </Container>
    );
  }
}

export default StaffManage;
